// Объект с путями к изображениям
const images = {
  // Логотип
  logo: '/image/Vector.png',
  
  // Иконки навигации
  dashboard: '/image/header/dashboard.png',
  dashboardActive: '/image/header/solar_widget-5-bold.png',
  people: '/image/header/people.png',
  peopleActive: '/image/header/solar_home-2-linear.png',
  user: '/image/header/solar_user-linear.png',
  userActive: '/image/header/solar_user-linear_active.png',
  exportOutline: '/image/header/solar_export-outline.png',
  exportOutlineActive: '/image/header/solar_export-outline-active.png',
  importLinear: '/image/header/solar_import-linear.png',
  importLinearActive: '/image/header/solar_import-linear-active.png',
  filtersLinear: '/image/header/solar_filters-linear.png',
  filtersLinearActive: '/image/header/solar_filters-linear-active.png',
  bellBold: '/image/header/solar_bell-bold.png',

  // Иконки footer
  telegram: '/image/header/ic_baseline-telegram.png',
  question: '/image/header/solar_question-circle-linear.png',
  logout: '/image/header/solar_logout-linear.png',

  // Иконки страницы авторизации
  lock: '/image/login/solar_lock-keyhole-minimalistic-linear.png',
  eye: '/image/login/solar_eye-linear.png',

  // Иконки страницы Мои потоки
  winrarOutline: '/image/solar_winrar-outline.png',
  winrarOutlineBig: '/image/solar_winrar-outline-big.png',

  // Иконки страницы Мои лиды
  leads: '/image/solar_users-group-two-rounded-bold.png',
  report: '/image/solar_folder-with-files-linear.png',
  filter: '/image/solar_filter-linear.png',
  search: '/image/solar_magnifer-linear.png',

  // Иконки страницы Профиль
  userProfile: '/image/user-linear.png',
  qrCode: '/image/solar_qr-code-broken.png',
  letter: '/image/solar_letter-linear.png',
  chatMoney: '/image/solar_chat-round-money-linear.png',
  downloadLinear: '/image/solar_download-linear.png',
  exitLinear: '/image/solar_exit-linear.png',
  paperclipBoldActive: '/image/solar_paperclip-bold-active.png',
  documentLinear: '/image/solar_document-linear.png',
  qrCodeBrokenBig: '/image/solar_qr-code-broken-big.png',
  copyLinear: '/image/solar_copy-linear.png',

  // Иконки страницы Рекламодатели
  eyeLinear: '/image/Advertisers/solar_eye-linear.png',
  letterOutline: '/image/Advertisers/solar_letter-outline.png',
  lockPasswordUnlockedOutline: '/image/Advertisers/solar_lock-password-unlocked-outline.png',
  walletLinear: '/image/Advertisers/solar_wallet-2-linear.png',

  // Модальные окна
  cloud: '/image/solar_cloud-download-outline.png',
  paperclip: '/image/solar_paperclip-bold.png',
  moneyLinear: '/image/solar_wad-of-money-linear.png',
  filesBroken: '/image/solar_folder-with-files-broken.png',
  doubleArrowDownLinear: '/image/solar_double-alt-arrow-down-linear.png',
  questionActive: '/image/ph_question.png',

  // Дополнительные иконки
  penLinear: '/image/solar_pen-linear.png',
  fileDownloadLinear: '/image/solar_file-download-linear.png',

  // Фоновые изображения
  loginBackground: '/image/login_background.png'
};

export default images;